import {useMatch} from "react-router-dom";
import EmailLink from "./email-link";
import PdfLink from "./pdf-link";

export default function AdminLinks() {
  const match = useMatch("/admin/personality/:assessmentID/:adminToken") || {params: {}};
  const {adminToken, assessmentID} = match.params;

  return (
    <>
      <EmailLink assessmentID={assessmentID} />
      <PdfLink adminToken={adminToken} assessmentID={assessmentID} />
    </>
  );
}
